import { type MenuPublic } from '../entities/MenuPublic'

export const MenuPublicHome = 'home'
export const MenuPublicCottages = 'cottages'

const menu: MenuPublic = [
  {
    id: MenuPublicHome,
    name: 'menu.menu.home',
    href: '/',
    icon: 'i-heroicons-magnifying-glass',
    selected: false,
  },
  {
    id: MenuPublicCottages,
    name: 'menu.menu.cottages',
    href: '/casas-rurales',
    icon: 'i-heroicons-home',
    selected: false,
  },
  {
    id: 'guides',
    name: 'menu.menu.guides',
    href: '/que-hacer',
    icon: 'i-heroicons-map',
    selected: false,
  },
  {
    id: 'deals',
    name: 'menu.menu.deals',
    href: '/ofertas-casas-rurales',
    icon: 'i-heroicons-receipt-percent',
    selected: false,
  },
  {
    id: 'inspiration',
    name: 'menu.menu.inspiration',
    href: '/blog/',
    icon: 'i-heroicons-book-open',
    selected: false,
  },
]

export default menu
